export default __webpack_public_path__ + "static/media/ic-interviews-icon.e15986e8.svg";